import { useLazyQuery } from "@apollo/client";
import React, { useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import DetailReportsList from "../../components/DetailReportsList/DetailReportsList";
import { DOWNLOAD_PENDING_USERS_ANSWER } from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { GeneralStyle } from "./DetailReportsContainer.styled";

const DetailReportsContainer = () => {
  const user = useMemo(() => getStateLoginComplete(), []);
  const titleOfTable = useMemo(() => "", []);
  const [dataExport, setDataExport] = useState([]);
  const [open, setOpen] = useState(false);
  const [showUsersAsnwered, setShowUsersAsnwered] = useState(0);
  const history = useHistory();
  const [nameFile, setNameFile] = useState("");

  const [runQueryDownloadPendingUsers] = useLazyQuery(
    DOWNLOAD_PENDING_USERS_ANSWER,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.downloadPendingUsersAnswersBySurvey.withError) {
          setDataExport(data.downloadPendingUsersAnswersBySurvey.outputData);
        }
      },
    }
  );

  let handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const getInfoUsersAnswered = (idSurvey) => {
    setShowUsersAsnwered(idSurvey);
  };

  const goToReport = (rowData) => {
    history?.push({
      pathname: `/ReportSurvey`,
      state: { idSurvey: rowData.idSurvey, surveyName: rowData.surveyName },
    });
  };

  // useEffect(() => {
  //   if (data) {
  //     if (
  //       user.roleId !==  ROLES.AGENT
  //     ) {
  //       if (data?.allSurveyReport?.outputData) {
  //         setDetailReportsList(
  //           data.allSurveyReport.outputData
  //             .filter((f) => {
  //               if (f.idSurveyState !== 4 && f.idSurveyState !== 1) {
  //                 if (user.roleId === ROLES.GAM || user.roleId === ROLES.SUPER_ADMIN) {
  //                   return true
  //                 } else if (user.roleId === ROLES.COUNTRY_ADMIN) {
  //                   return f.countryId === userdata?.currentUserInfo?.countryId
  //                 } else {
  //                   return f.createUser === user.userName
  //                 }
  //               } else {
  //                 return false
  //               }
  //             })
  //             .sort((a, b) => {
  //               return b.idSurvey - a.idSurvey
  //             })
  //             .map((item) => ({ ...item })),
  //         )
  //       } else {
  //         setDetailReportsList([])
  //       }
  //     }
  //   }
  // }, [data, user, reloadSurveyList, userdata])

  const handleDownloadRemaining = (rowData) => {
    setNameFile("remainingSurveys_" + rowData.idSurvey);
    runQueryDownloadPendingUsers({
      variables: {
        idSurvey: rowData.idSurvey,
        surveyName: rowData.surveyName,
      },
    });
  };

  return (
    <GeneralStyle>
        <DetailReportsList
          dataExport={dataExport}
          nameFile={nameFile}
          user={user}
          handleClose={handleClose}
          open={open}
          handleDownloadRemaining={handleDownloadRemaining}
          showUsersAsnwered={showUsersAsnwered}
          setShowUsersAsnwered={setShowUsersAsnwered}
          getInfoUsersAnswered={getInfoUsersAnswered}
          goToReport={goToReport}
          titleOfTable={titleOfTable}
        />
      </GeneralStyle>
  );
};

export default DetailReportsContainer;
